var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 17,
    viewBox: "0 0 15 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.75 3.75H2.19444H13.75",
    stroke: "#C11D1D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 3.75V14.25C12.75 14.6478 12.5844 15.0294 12.2897 15.3107C11.995 15.592 11.5953 15.75 11.1786 15.75H3.32143C2.90466 15.75 2.50496 15.592 2.21026 15.3107C1.91556 15.0294 1.75 14.6478 1.75 14.25V3.75M4.10714 3.75V2.25C4.10714 1.85218 4.2727 1.47064 4.5674 1.18934C4.8621 0.908035 5.2618 0.75 5.67857 0.75H8.82143C9.2382 0.75 9.6379 0.908035 9.9326 1.18934C10.2273 1.47064 10.3929 1.85218 10.3929 2.25V3.75",
    stroke: "#C11D1D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.75 6.75V11.75",
    stroke: "#C11D1D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.75 6.75V11.75",
    stroke: "#C11D1D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/deleteIcon.6d064bd40d4b699d8fc59b7b59b7954c.svg";
export { ForwardRef as ReactComponent };